export function isJSON(str: string): boolean {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }

  return true;
}

export function getCdnImage(image: string) {
  if (!image) {
    return 'https://invalid.eduzz.com';
  }

  if (image.includes('data:')) {
    return image;
  }

  if (image.startsWith('https://')) {
    return image;
  }

  const numberImage = Number(image);

  if (isNaN(numberImage)) {
    return `https://cdn.eduzzcdn.com/${image}`;
  }

  return `https://my.eduzz.com/file_upload/redirect/${image}/false`;
}
